import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "shape-slide__wrapper" }
const _hoisted_2 = { class: "shape-slide__shape-container" }
const _hoisted_3 = { class: "shape-slide__logo-title" }
const _hoisted_4 = { class: "shape-slide__title" }
const _hoisted_5 = { class: "shape-slide__content" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_7 = { class: "shape-slide__text" }
const _hoisted_8 = { class: "shape-slide__title" }
const _hoisted_9 = { class: "text" }
const _hoisted_10 = {
  key: 0,
  class: "shape-slide__highlight-text"
}
const _hoisted_11 = { class: "shape-slide__link" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["shape-slide", [{ 'shape-slide--right': _ctx.right, 'shape-slide--revealed': _ctx.revealed, 'shape-slide--history': _ctx.isHistory }, `shape-slide--${_ctx.icon}`]]),
    onMouseenter: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.reveal && _ctx.reveal(...args))),
    onMouseleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.conceal && _ctx.conceal(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "shape-slide__shape",
          style: _normalizeStyle({ backgroundImage: `url(${_ctx.image})` })
        }, null, 4),
        _createVNode(_component_icon, {
          name: _ctx.right ? 'icn-shape-slide-right' : 'icn-shape-slide-left',
          class: "shape-slide__shape-svg"
        }, null, 8, ["name"]),
        _createElementVNode("div", _hoisted_3, [
          (_ctx.icon && _ctx.icon !== 'none')
            ? (_openBlock(), _createBlock(_component_icon, {
                key: 0,
                name: _ctx.icon,
                class: "shape-slide__icon"
              }, null, 8, ["name"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.title), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.title), 1),
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.text), 1),
          (_ctx.highlightText)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.highlightText), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ]),
      (_ctx.revealed)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "shape-slide__more-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.revealed = false))
          }, [
            _createVNode(_component_icon, {
              name: "icn-cross",
              class: "shape-slide__more-btn-icon"
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ], 34))
}